import { Injectable } from '@angular/core';
import { BrowserNavigationService, DeferredNavigation } from './browser-navigation.service';
import { InAppBrowserService } from '../in-app-browser.service';


@Injectable()
export class NativeBrowserNavigationService extends BrowserNavigationService {
  constructor(private readonly inAppBrowser: InAppBrowserService) {
    super();
  }

  open(url: string): void {
    this.inAppBrowser.openExternalBrowser(url);
  }

  beginDeferredNavigation(): DeferredNavigation {
    return {
      navigate: (url: string) => this.open(url),
      cancel: () => undefined
    };
  }
}
